<template>
  <div class="about">
    <h2>Transfer Pilots From Event to Box</h2>
    <SelectBoxForAdmin
      @box_changed="boxSelected"
      v-if="showBoxList"
    ></SelectBoxForAdmin>
    <v-row>
      <v-col cols="2">
        <v-btn
          v-if="!showBoxList"
          @click="showBoxList = !showBoxList"
          small
          rounded
          color="primary"
          >Show Boxes</v-btn
        >
      </v-col>
      <v-col
        ><v-chip small v-if="boxIsSelected">Selected box: {{ this.boxname }} </v-chip>
        <v-chip small color="red" v-if="!boxIsSelected">No box selected! </v-chip>
        </v-col
      >
    </v-row>
    <v-card outlined raised max-width="300" v-if="boxIsSelected">
      <v-label>Select date to transfer to.</v-label>
      <v-date-picker v-model="date" ></v-date-picker>
      <v-spacer></v-spacer>
      <v-row justify="center">
        <v-col></v-col>
        <v-col>
          <v-btn color="primary" @click="transfer" :disabled="transferDisabled"
            >Transfer</v-btn
          >
        </v-col>
        <v-col>
          <v-btn link :to="cancellink.to">Cancel</v-btn>
        </v-col>
        <v-col></v-col>
      </v-row>
      <div>.</div>
      <v-alert type="success" :value="isAlertVisible" dense>
        {{ statusResultMsg }}
        <div>.</div>
        <v-btn link :to="cancellink.to">OK</v-btn>
      </v-alert>
      <v-alert type="error" :value="isWarningAlertVisible" dense>
        {{ statusResultMsg }}
        <div>.</div>
        <v-btn link :to="cancellink.to">OK</v-btn>
      </v-alert>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import SelectBoxForAdmin from "@/components/airbox/SelectBoxForAdmin.vue";

export default {
  name: "Transfer",
  props: {
    happ: [],
    regId: Number,
    ac: String,
  },
  // regid: Number,
  data() {
    return {
      //   eyevalueac: true,
      //   eyevaluepw: true,
      //   isValid: true,
      //   regidRules: [(v) => !!v || "User is required"],
      //   acRules: [(v) => !!v || "Access code is required"],
      //   pwRules: [(v) => !!v || "Password is required"],
      //   cancellink: { to: "/checkin" },
      cancellink: { to: "/" },
      isAlertVisible: false,
      isWarningAlertVisible: false,
      statusResult: Number,
      statusResultMsg: String,
      transferDisabled: false,
      //   cancelBtnText: "",
      //   statuses: [],
      //   errors: [],
      //   snackbar: false,
      //   snackbartext: "No info.",
      //   loginModel: null,

      //   fromDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      //     .toISOString()
      //     .substr(0, 10),
      toDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      //   menu: false,
      //   modal: false,
      //   menu2: false,
      date: null,
      box: [],
      boxname: String,
      boxid: Number,
      boxIsSelected: false,
      showBoxList: true,
    };
  },
  created() {
    //this.baseUrl = "http://localhost:3000/dbapi/";
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.regid = null;
    // this.isValid = false;
    // this.ac = null;
    // this.pw = null;
  },
  methods: {
      boxSelected(boxSelected) {
      this.box = boxSelected;
      this.boxname = boxSelected.Event;
      this.boxid = boxSelected.EventId;
      this.boxIsSelected = true;
      this.showBoxList = false;
    },
    transfer() {
      var regId = this.regId;
      var ac = this.ac;
      var eventId = this.box.EventId;
      var happId = this.happ.HappId;

      // var fromDate = this.fromDate;
      // var toDate = this.toDate;
      //   var fromDate = this.dates[0]; //this.fromDate;
      //   if (this.dates.length < 1) {
      //     fromDate = this.fromDate;
      //   }
      var toDate = this.date; //this.toDate;
      if (this.date == null) {
        toDate = this.toDate;
      }

      var toSubmit = JSON.stringify({ regId, ac, happId, eventId, toDate });
      const uri = this.baseUrl + "transferHappPilotsToBox";
      console.log("toSubmit", toSubmit);
      console.log("uri", uri);
      this.sendpost(uri, toSubmit, 1);
    },

    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          if (this.statusResult == 1) {
            this.cancelBtnText = "Done";
            console.log(response.data);
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
      this.transferDisabled = true;
    },
  },
  components: {
    SelectBoxForAdmin,
  }
};
</script>